import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './index.scss';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { IResult } from '../../global.d';
import { style } from '../../utils/image';
import cookies from '../../utils/cookie';
import { alpha } from '../../utils/color';

export interface INoticeQrcode {
  image?: string;
  text?: string;
  videoid: number;
  rootStore?: RootStore;
}

const NoticeModal = (props: {
  imageUrl: string;
  text?: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}) => {
  const { visible, imageUrl, text, setVisible } = props;
  return createPortal(
    <div className={`notice-modal ${visible ? 'visible' : ''}`}>
      <div className="wrapper">
        <div className="title">{intl.get('QrcodeNoticeTitle')}</div>
        <div className="qrcode">
          {!!imageUrl ? <img src={imageUrl} /> : null}
        </div>
        <div className="tips">
          {text ? (
            (text || '').split(/\n/).map((it: string, index: number) => {
              return <p key={index}>{it}</p>;
            })
          ) : (
            <>
              <p>{intl.get('QrcodeNoticeFollow')}</p>
              <p>{intl.get('QrcodeNoticeTips')}</p>
            </>
          )}
        </div>
        <div
          className="close"
          onClick={() => {
            setVisible(false);
          }}
        >
          <img src={require('../../assets/x-white.png')} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default inject('rootStore')(
  observer((props: INoticeQrcode) => {
    const { videoid, image, text } = props;
    const [visible, setVisible] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [isOrder, setIsOrder] = useState(false);

    const clickHandler = () => {
      setVisible(true);

      if (image) {
        setImageUrl(style(image, 'qrcode_180'));
      } else {
        fetchTicket();
      }
    };

    useEffect(() => {
      if (videoid) {
        let needToShowCancel = cookies.getItem('cancel');
        if (needToShowCancel) {
          cookies.removeItem('cancel', '/');
          props.rootStore!.uiStore.showToast({
            content: intl.get('QrcodeNoticeCancel'),
            time: 1500
          });
        }
      }
    }, [videoid]);

    useEffect(() => {
      if (videoid) {
        props
          .rootStore!.galleryStore.getNoticeStatus(videoid)
          .then((res: IResult) => {
            if (res && res.code == 200) {
              setIsOrder(!!res.data);
            }
          });
      }
    }, [videoid]);

    const { galleryStore } = props.rootStore!;
    const fetchTicket = () => {
      galleryStore
        .getVideoQrcodeTicket(videoid, window.pageDetail.link_id)
        .then((res: IResult) => {
          setImageUrl(
            `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${encodeURIComponent(
              res.data
            )}`
          );
        });
    };

    return (
      <ThemeContext.Consumer>
        {theme => (
          <div className="video-notice">
            {isOrder ? (
              <button
                className={'send-button'}
                style={{
                  backgroundColor: theme.mainColor,
                  color: alpha(theme.componentColor, 1)
                }}
              >
                {intl.get('QrcodeNoticeOrdered')}
              </button>
            ) : (
              <button
                className={'send-button'}
                onClick={clickHandler}
                style={{
                  backgroundColor: theme.mainColor,
                  color: alpha(theme.componentColor, 1)
                }}
              >
                {intl.get('QrcodeNotice')}
              </button>
            )}
            <NoticeModal
              visible={visible}
              imageUrl={imageUrl}
              text={text}
              setVisible={setVisible}
            />
          </div>
        )}
      </ThemeContext.Consumer>
    );
  })
);
